// src/pages/sacramentos/Sacramentos.js

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getSacramentos } from '../../services/api';
import batismoIcon    from '../../assets/batismo_icon.png';
import eucaristiaIcon from '../../assets/eucaristia_icon.png';
import crismaIcon     from '../../assets/crisma_icon.png';
import matrimonioIcon from '../../assets/noivos_icon.png';

const ICONES = {
  batismo:    batismoIcon,
  eucaristia: eucaristiaIcon,
  crisma:     crismaIcon,
  matrimonio: matrimonioIcon,
};

const DEFAULTS = [
  {
    id: 'batismo',
    titulo: 'Batismo',
    conteudo: `O Batismo é o primeiro dos sete sacramentos da Igreja Católica e a porta de entrada para a vida cristã. Através do Batismo, o fiel é libertado do pecado original, torna-se filho de Deus e membro da Igreja.

Orientações:
• Crianças até 6 anos: inscrição pela página de Batismo
• Para maiores de 6 anos: procure a secretaria paroquial
• Taxa: R$ 100,00 (paga na 1ª reunião)
• Documentos: certidão de nascimento e documentos dos padrinhos`,
    link: '/batismo',
    linkLabel: 'Fazer inscrição',
  },
  {
    id: 'eucaristia',
    titulo: 'Primeira Eucaristia',
    conteudo: `A Primeira Eucaristia é o momento em que a criança recebe pela primeira vez o Corpo e o Sangue de Cristo na Santa Missa, marcando o início de uma participação plena na vida sacramental da Igreja.

Orientações:
• Idade mínima: 7 anos (idade da razão)
• Preparação: catequese de Iniciação Cristã
• A preparação inclui catequese, retiro e encontros com os pais
• Contato: secretaria paroquial`,
    link: null,
  },
  {
    id: 'crisma',
    titulo: 'Crisma',
    conteudo: `O Sacramento da Crisma completa a iniciação cristã e fortalece o cristão com os dons do Espírito Santo para viver e defender a fé, como os Apóstolos receberam no Pentecostes.

Orientações:
• Idade mínima: 14 anos
• Pré-requisito: Batismo e Primeira Eucaristia
• Preparação: catequese específica com duração de 2 anos
• Escolha de um padrinho ou madrinha
• Procure a secretaria para informações sobre os grupos`,
    link: null,
  },
  {
    id: 'matrimonio',
    titulo: 'Matrimônio',
    conteudo: `O Sacramento do Matrimônio une um homem e uma mulher num vínculo perpétuo e exclusivo, abençoado e santificado por Deus, num compromisso sagrado e público diante da comunidade cristã.

Orientações:
• Marcação: com pelo menos 6 meses de antecedência
• Pré-requisito: ambos devem ter recebido o Batismo
• Curso de Noivos: obrigatório
• Documentos: certidões de batismo, documentos pessoais, certidão civil (se houver)
• Agende uma conversa com o pároco na secretaria`,
    link: '/noivos',
    linkLabel: 'Inscrição no Curso de Noivos',
  },
];

const Sacramento = ({ s }) => {
  const [open, setOpen] = useState(false);
  const icone = ICONES[s.id] || ICONES[s.id?.toLowerCase()];

  return (
    <div style={{
      background: 'var(--white)',
      borderRadius: 'var(--radius-lg)',
      boxShadow: open ? 'var(--shadow-lg)' : 'var(--shadow-sm)',
      overflow: 'hidden',
      border: `1px solid ${open ? 'var(--gold)' : 'var(--gray-100)'}`,
      transition: 'all 0.2s ease',
    }}>
      <button
        onClick={() => setOpen(o => !o)}
        style={{
          width: '100%',
          background: open ? 'var(--gold-pale)' : 'var(--white)',
          border: 'none',
          padding: '1.25rem 1.75rem',
          display: 'flex',
          alignItems: 'center',
          gap: '1rem',
          cursor: 'pointer',
          textAlign: 'left',
          transition: 'background 0.2s',
        }}
      >
        {/* Ícone */}
        <div style={{
          width: 48, height: 48,
          borderRadius: '50%',
          background: open ? 'var(--navy)' : 'var(--off-white)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
          transition: 'background 0.2s',
          overflow: 'hidden',
          padding: icone ? '6px' : 0,
        }}>
          {icone ? (
            <img
              src={icone}
              alt={s.titulo}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'contain',
                filter: open
                  ? 'invert(1)'
                  : 'invert(20%) sepia(50%) saturate(500%) hue-rotate(190deg)',
                transition: 'filter 0.2s',
              }}
            />
          ) : (
            <span style={{ fontSize: '1.4rem' }}>✝️</span>
          )}
        </div>

        <span style={{
          fontFamily: 'var(--font-display)',
          fontSize: '1.2rem',
          fontWeight: 600,
          color: 'var(--navy)',
          flex: 1,
        }}>
          {s.titulo}
        </span>

        <span style={{
          color: 'var(--gold)',
          fontSize: '1.1rem',
          transform: open ? 'rotate(180deg)' : 'none',
          transition: 'transform 0.25s',
          flexShrink: 0,
        }}>▾</span>
      </button>

      {open && (
        <div style={{ padding: '0 1.75rem 1.75rem', borderTop: '1px solid var(--gray-100)' }}>
          <div style={{ height: 3, width: 40, background: 'var(--gold)', margin: '1.25rem 0' }} />
          <p style={{
            color: 'var(--gray-600)', lineHeight: 1.9,
            whiteSpace: 'pre-wrap', fontSize: '0.95rem',
            marginBottom: s.link ? '1.25rem' : 0,
          }}>
            {s.conteudo}
          </p>
          {s.link && (
            <Link to={s.link} className="btn btn-primary btn-sm">
              {s.linkLabel} →
            </Link>
          )}
        </div>
      )}
    </div>
  );
};

const Sacramentos = () => {
  const [sacramentos, setSacramentos] = useState(DEFAULTS);

  useEffect(() => {
    getSacramentos()
      .then(r => { if (r?.data?.length) setSacramentos(r.data); })
      .catch(() => {});
  }, []);

  return (
    <main style={{ paddingTop: '72px' }}>

      {/* Hero */}
      <section style={{
        background: 'linear-gradient(135deg, var(--navy-dark) 0%, var(--navy) 100%)',
        padding: 'var(--space-2xl) var(--space-xl)',
        textAlign: 'center', position: 'relative', overflow: 'hidden',
      }}>
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'radial-gradient(circle, rgba(201,160,48,0.07) 1px, transparent 1px)', backgroundSize: '40px 40px', pointerEvents: 'none' }} />
        <div style={{ position: 'relative' }}>
          <div className="ornament" style={{ justifyContent: 'center', marginBottom: '0.75rem' }}>Igreja Católica</div>
          <h1 style={{ color: 'var(--white)', marginBottom: '0.5rem' }}>Sacramentos</h1>
          <p style={{ color: 'rgba(255,255,255,0.7)', maxWidth: 560, margin: '0 auto', lineHeight: 1.8 }}>
            Os sinais eficazes da graça, instituídos por Cristo e confiados à Igreja,
            pelos quais a vida divina nos é dispensada.
          </p>
        </div>
      </section>

      {/* Cards resumo */}
      <section style={{ background: 'var(--off-white)', padding: 'var(--space-xl) var(--space-xl)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 'var(--space-md)' }}>
            {DEFAULTS.map(s => {
              const icone = ICONES[s.id];
              return (
                <div key={s.id} style={{
                  background: 'var(--white)', borderRadius: 'var(--radius-md)',
                  padding: 'var(--space-lg)', textAlign: 'center',
                  boxShadow: 'var(--shadow-sm)', borderTop: '3px solid var(--gold)',
                }}>
                  <div style={{ width: 52, height: 52, margin: '0 auto 0.75rem', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {icone ? (
                      <img src={icone} alt={s.titulo}
                        style={{ width: '100%', height: '100%', objectFit: 'contain', filter: 'invert(20%) sepia(50%) saturate(500%) hue-rotate(190deg)' }} />
                    ) : (
                      <span style={{ fontSize: '2rem' }}>✝️</span>
                    )}
                  </div>
                  <p style={{ fontWeight: 600, color: 'var(--navy)', fontSize: '0.9rem' }}>{s.titulo}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Acordeão */}
      <section style={{ background: 'var(--white)', padding: 'var(--space-2xl) var(--space-xl)' }}>
        <div className="container" style={{ maxWidth: 800 }}>
          <h2 className="section-title" style={{ marginBottom: '0.75rem' }}>Saiba mais sobre cada sacramento</h2>
          <p style={{ textAlign: 'center', color: 'var(--gray-400)', marginBottom: 'var(--space-xl)', fontSize: '0.95rem' }}>
            Clique em cada sacramento para ver orientações e informações detalhadas.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            {sacramentos.map(s => (
              <Sacramento key={s.id || s.titulo} s={s} />
            ))}
          </div>
        </div>
      </section>

    </main>
  );
};

export default Sacramentos;